<template>
  <div class="brand">
    <router-link exact :to="{ name: routeName }">
      <Component :is="logoComp" height="26" :alt="logoAlt" :title="logoAlt" />
    </router-link>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import Christmas from '@/components/Christmas'
import NewYear from '@/components/NewYear'

export default {
  components: {
    Logo,
    Christmas,
    NewYear
  },
  data () {
    return {
      logoComp: 'Logo',
      logoAlt: 'Superchargify'
    }
  },
  props: {
    routeName: String
  },
  created () {
    return this.isChristmas() || this.isNewYear()
  },
  methods: {
    isChristmas () {
      const start = new Date(2019, 11, 24)
      const end = new Date(2019, 11, 28)
      const current = new Date()

      if (start <= current && current < end) {
        this.logoComp = 'Christmas'
        this.logoAlt = 'Superchargify: Merry Christmas!'

        return true
      }
    },
    isNewYear () {
      const start = new Date(2019, 11, 28)
      const end = new Date(2020, 0, 10)
      const current = new Date()

      if (start <= current && current < end) {
        this.logoComp = 'NewYear'
        this.logoAlt = 'Superchargify: Happy New Year!'

        return true
      }
    }
  }
}
</script>
